import { render, staticRenderFns } from "./DragHandle.vue?vue&type=template&id=406e3c8c&scoped=true"
var script = {}
import style0 from "./DragHandle.vue?vue&type=style&index=0&id=406e3c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406e3c8c",
  null
  
)

export default component.exports